module.exports = __webpack_public_path__ + "static/media/How to change currency and bank info.b6fdcffe.png";